// extracted by mini-css-extract-plugin
export var brand = "index-module--brand--yPa7l";
export var title = "index-module--title--Vu0kN";
export var brand_main = "index-module--brand_main--03ReH";
export var brand_item = "index-module--brand_item--Md8QW";
export var data_show = "index-module--data_show--hf-v8";
export var bold = "index-module--bold--NyLuZ";
export var normal = "index-module--normal--I+Rte";
export var card = "index-module--card--Er1lc";